import _moveFormattedWord from "./moveFormattedWord.js";
const moveFormattedWord = _moveFormattedWord;
const {
  getWords,
  peekFirstWord,
  peekLastWord,
  extractFirstWord,
  extractLastWord,
  appendWord,
  prependWord,
  createParagraphFromFragment,
  displayLength,
  movedLineLength
} = moveFormattedWord;
export default (function compressText(htmlString, maxCharLimit = 32, maxParagraphLimit = 4) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const paragraphs = Array.from(doc.getElementsByTagName("p"));
  const getCharCount = element => element.textContent.length;
  const findLongestParagraph = () => {
    let maxLength = 0;
    let maxIndex = 0;
    paragraphs.forEach((p, index) => {
      const length = getCharCount(p);
      if (length > maxLength) {
        maxLength = length;
        maxIndex = index;
      }
    });
    return {
      index: maxIndex,
      length: maxLength
    };
  };
  let modified = false;
  let iterations = 0;
  const maxIterations = 100;
  while (!modified && iterations < maxIterations) {
    iterations++;
    const {
      index: longestParaIndex,
      length: currentLongest
    } = findLongestParagraph();
    if (paragraphs.length < maxParagraphLimit) {
      const lastParagraph = paragraphs[paragraphs.length - 1];
      const peek = peekLastWord(lastParagraph);
      if (peek && peek.wordCount > 1) {
        if (peek.wordText.length <= maxCharLimit && peek.remainingText.length <= maxCharLimit) {
          const extracted = extractLastWord(lastParagraph);
          if (extracted) {
            const newPara = createParagraphFromFragment(lastParagraph, extracted.fragment);
            lastParagraph.parentNode.appendChild(newPara);
            paragraphs.push(newPara);
            modified = true;
            break;
          }
        }
      }
    }
    if (!modified) {
      const longestPeekFirst = peekFirstWord(paragraphs[longestParaIndex]);
      const longestWords = getWords(paragraphs[longestParaIndex]);
      if (longestWords.length > 1) {
        if (longestParaIndex > 0 && longestPeekFirst) {
          const prevPara = paragraphs[longestParaIndex - 1];
          const newPrevLength = movedLineLength(displayLength(prevPara), longestPeekFirst.wordText);
          const newCurrentLength = longestPeekFirst.remainingText.length;
          if (newPrevLength <= maxCharLimit && newCurrentLength <= maxCharLimit && Math.max(newPrevLength, newCurrentLength) < currentLongest) {
            const extracted = extractFirstWord(paragraphs[longestParaIndex]);
            if (extracted) {
              appendWord(prevPara, extracted.fragment);
              modified = true;
              break;
            }
          }
        }
        const longestPeekLast = peekLastWord(paragraphs[longestParaIndex]);
        if (longestParaIndex < paragraphs.length - 1 && longestPeekLast) {
          const nextPara = paragraphs[longestParaIndex + 1];
          const newNextLength = movedLineLength(displayLength(nextPara), longestPeekLast.wordText);
          const newCurrentLength = longestPeekLast.remainingText.length;
          if (newNextLength <= maxCharLimit && newCurrentLength <= maxCharLimit && Math.max(newCurrentLength, newNextLength) < currentLongest) {
            const extracted = extractLastWord(paragraphs[longestParaIndex]);
            if (extracted) {
              prependWord(nextPara, extracted.fragment);
              modified = true;
              break;
            }
          }
        }
      }
      if (!modified) {
        for (let i = 0; i < paragraphs.length - 1; i++) {
          if (i === longestParaIndex) continue;
          const currentPara = paragraphs[i];
          const nextPara = paragraphs[i + 1];
          const peek = peekLastWord(currentPara);
          if (peek && peek.wordCount > 1) {
            const newCurrentLength = peek.remainingText.length;
            const newNextLength = movedLineLength(displayLength(nextPara), peek.wordText);
            const oldCurrentLength = currentPara.textContent.length;
            if (newCurrentLength <= maxCharLimit && newNextLength <= maxCharLimit && newCurrentLength < oldCurrentLength && newNextLength < oldCurrentLength) {
              const extracted = extractLastWord(currentPara);
              if (extracted) {
                prependWord(nextPara, extracted.fragment);
                modified = true;
                break;
              }
            }
          }
        }
      }
    }
    if (!modified && paragraphs.length < maxParagraphLimit && longestParaIndex === paragraphs.length - 1) {
      const peek = peekLastWord(paragraphs[longestParaIndex]);
      if (peek && peek.wordCount > 1) {
        if (peek.wordText.length <= maxCharLimit && peek.remainingText.length <= maxCharLimit) {
          const extracted = extractLastWord(paragraphs[longestParaIndex]);
          if (extracted) {
            const newPara = createParagraphFromFragment(paragraphs[longestParaIndex], extracted.fragment);
            paragraphs[longestParaIndex].parentNode.appendChild(newPara);
            paragraphs.push(newPara);
            modified = true;
            break;
          }
        }
      }
    }
    if (!modified) break;
  }
  if (!modified || iterations >= maxIterations) return htmlString;
  return Array.from(doc.body.getElementsByTagName("p")).map(p => p.outerHTML).join("");
});